import { render } from "./navHeader.vue?vue&type=template&id=f2c915b0"
import script from "./navHeader.vue?vue&type=script&lang=js"
export * from "./navHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__